<template>
    <div>
        <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
            <div class="row mb-2">
                <div class="col-12 col-md-6 col-lg-6 col-xl-6">
                    <h1 class="text-white pt-3">รายงานใบเสร็จรับเงิน</h1>
                    <p class="text-white">สรุปรายงานใบเสร็จรับเงิน</p>
                </div>

                <template>
                    <div class="col-12 col-md-6 col-lg-6 col-xl-6 d-flex justify-content-end align-items-center">
                        <div class="btn-export-new">
                            <ExportExcel
                                :columns="fields"
                                :getData="getReportExcel"
                                name="ใบเสร็จ "
                                :titleBtn="'Export'"
                            >
                            </ExportExcel>
                        </div>
                    </div>
                </template>
            </div>
            <CardTotalReceipt
                v-if="!this.$USER_LOGIN.get().isAdmin"
                :reportReceipt="reportReceipt"
            />
        </base-header>
        <div class="text-center" v-if="reportReceipt.busy">
            <BlockUI>
                <div class="loader"></div>
            </BlockUI>
        </div>
        <div class="container-fluid mt--8 mb-5">
            <div class="row">
                <div class="col">
                    <!-- <div class="card shadow" v-if="this.$USER_LOGIN.get().isShippop">
                        <SearchReceipt :search="search" @getReport="getReport" />
                        <TableReceipt :search="search" :reportReceipt="reportReceipt" @getReport="getReport" :type="type" />
                    </div>
                    <div class="tab-report" v-else-if="this.$USER_LOGIN.get().isSuperadmin">
                        <SearchReceipt :search="search" @getReport="getReport" />
                        <TableReceipt :search="search" :reportReceipt="reportReceipt" @getReport="getReport" :type="type" />
                    </div>
                    <div class="card shadow" v-else-if="this.$USER_LOGIN.get().isAdmin">
                        <SearchReceipt :search="search" @getReport="getReport" />
                        <TableReceipt :search="search" :reportReceipt="reportReceipt" @getReport="getReport" :type="type" />
                    </div> -->
                    <div class="tab-report">
                        <SearchReceipt :search="search" @getReport="getReport" />
                        <TableReceipt :search="search" :reportReceipt="reportReceipt" @getReport="getReport" :type="type" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import SearchReceipt from '@/components/custom/reportReceipt/SearchReceipt'
import TableReceipt from '@/components/custom/reportReceipt/TableReceipt'
import { getReportReceipt, getReportReceiptForExcel } from '@/axios/receipt'
import { showErrorModal } from '@/components/modalNotification'
import ExportExcel from '@/components/custom/exportExcel/ExportExcel'
import { fieldExport, fieldShopExport } from '@/components/custom/reportReceipt/fieldExcelReceipt'
import CardTotalReceipt from '@/components/custom/reportReceipt/CardTotalReceipt'

export default {
    name: 'reportReceipt',
    components: {
        SearchReceipt,
        TableReceipt,
        ExportExcel,
        CardTotalReceipt
    },
    data() {
        return {
            type: '',
            reportReceipt: {
                busy: true,
                listReportReceipt: [],
                listTotalReceipt: {},
                isLoadingExcel: false,
                modalPay:{
                    show: false,
                    invoice: [],
                    type: null,
                    isLoading: false,
                    datePaid: null
                }
            },
            search: {
                isLoading: false,
                date: {
                    startDate: moment().subtract(1, 'months').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                },
                shopCode: null,
                saCode: null,
                receiptNo: null,
                status: null,
                paymentType: null,
                type: (this.$USER_LOGIN.get().isSuperadmin) ? 'superadmin' : null,
                totalPage: 1,
                totalItem: 0,
                page: 1,
                perPage: 25,
            }
        }
    },
    mounted() {
        this.type = !this.$USER_LOGIN.get().isAdmin ? 'RECEIPT' : 'RECEIPT_SELF'
        this.defaultLoad()
    },
    methods: {
        defaultLoad() {
            this.getReport()
        },
        async getReport() {
            try {
                this.reportReceipt.listReportReceipt = []
                this.reportReceipt.listTotalReceipt  = {}
                this.search.isLoading = true

                const res = await getReportReceipt(this.search)

                this.reportReceipt.listReportReceipt = res.item
                this.reportReceipt.listTotalReceipt  = res.total_invoices
                this.search.totalPage                = res.total_page
                this.search.totalItem                = res.total_item
                this.search.page                     = res.page
            } catch (error) {
                showErrorModal(error)
            } finally {
                this.reportReceipt.busy = false
                this.search.isLoading   = false
            }
        },
        async getReportExcel() {
            const results = []

            try {
                const reports = await getReportReceiptForExcel(this.search)
                for (const [index, report] of reports.entries()) {
                    results.push({
                        ...report,
                        index     : index + 1,
                        receipt_no: report.invoice_document_no
                    })
                }

                return results;
            } catch (error) {
                showErrorModal(error)
            }
        }
    },
    computed: {
        fields() {
            if (this.main_use_walletV2) {
                return fieldShopExport[this.type];
            }

            return fieldExport[this.type]
        }
    }
}
</script>
